// extracted by mini-css-extract-plugin
export default {"content":"DoorAccess_content__q0dLs","headerContainer":"DoorAccess_headerContainer__9oEe9","cell":"DoorAccess_cell__ilXzt"};